import React from 'react'
import { SupportSectionProps } from './types'

export default function SupportSection({
    title,
    description,
    className,
}: SupportSectionProps) {
    return (
        <li className={className}>
            <h3>{title}</h3>
            <p>{description}</p>
        </li>
    )
}
